import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../template/store';
import { useDispatch } from 'react-redux';
import EBLHeader from './EBLDetailsViewHeader';
import EBLDetails from './EBLDetails';
import EDocumentHistory from './EDocumentHistory';
import { getOBLDetails } from '../dashboard/actions/instruction';
import { AESDecrypt } from '../../../encrypt-util';
import { useParams } from 'react-router-dom';


const EBLSlider = () => {

    const dispatch = useDispatch<AppDispatch>();
    const { blId, encrypt } = useParams();

    const profileDetails = useSelector(
        (state: RootState) => state.userProfile.profile
    );
    const selectedLinerId = useSelector(
        (state: RootState) => state.navbarTop.linerId
    );
    const docType = AESDecrypt(encrypt);
    const blIdDecrypted = AESDecrypt(blId)

    useEffect(() => {
        if (blIdDecrypted && selectedLinerId)
            dispatch(
                getOBLDetails({
                    blNumber: blIdDecrypted || null,
                    selectedLinerId:
                        profileDetails.partnerType === 'liner'
                            ? profileDetails?.partnerId
                            : selectedLinerId,
                })
            );
    }, [blIdDecrypted, selectedLinerId, docType]);

    return (
        <>
            <EBLHeader />
            <EBLDetails />
            <EDocumentHistory />
        </>
    );
};

export default EBLSlider;
